import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { validateUser } from "../utils";
import { useDoubleCheck, useRedirect, useError } from "../hooks";

export default function Login() {
  const history = useHistory();
  const { setError } = useError();
  const [rawPhoneNumber, setRawPhoneNumber] = useState(
    window.localStorage.getItem("hub-phone") || ""
  );
  const redirect = useRedirect();

  useDoubleCheck();

  const submit = async function (e) {
    e.preventDefault();
    if (!rawPhoneNumber) {
      return;
    }
    const { body, error } = await validateUser(rawPhoneNumber);
    if (body) {
      if (redirect) {
        history.push(`/mfa?redirect=${redirect}`);
      } else {
        history.push("/mfa");
      }
    } else if (error) {
      setError(error);
    } else {
      setError(
        "There was an error with your phone number.\n\n\nPlease try entering it again."
      );
    }
  };

  return (
    <>
      <h1>Welcome to Hubert's HUB!</h1>
      <p>Hubert's HUB is a wiki for work, projects, or random ideas.</p>
      <p>
        HUB is created with mobile note-jotting in mind, so you can quickly
        update, look up, or add information on the go.
      </p>
      <form onSubmit={submit}>
        <label htmlFor="phoneNumber">Phone Number</label>
        <input
          autoFocus
          id="phoneNumber"
          value={rawPhoneNumber}
          onChange={({ target: { value } }) => setRawPhoneNumber(value)}
          required
          type="tel"
        />
        <p>
          <em>
            Note: Hubert's HUB is still in the alpha stages; functionality and
            uptime may be sporadic.
            <br />
            However the developer is{" "}
            <a
              href="https://en.wikipedia.org/wiki/Eating_your_own_dog_food"
              target="_blank"
              rel="noreferrer"
            >
              dogfooding
            </a>{" "}
            the app, so every effort to avoid data loss will be taken.
          </em>
        </p>
        <button type="submit" id="submit-btn">
          Submit
        </button>
      </form>
    </>
  );
}
